/**
 * .tuMetrics {"tu1": 0.94, "tu2": 0.95, "tu3": 2, "notes": "Feed team lens: null = all; named team scopes events", "tuVersion": "2.5"}
 * .help "Null team filter shows everything. A named home/private team scopes streams and cards. Company is not a filter option."
 */
import type { Card, FeedEvent, Roadmap, Sprint } from '../../types/index.ts';

export type TeamForFilter = { id: string; name: string };

export function eventBelongsToSelectedTeam(input: {
  event: FeedEvent;
  selectedTeamId: string | null;
  currentUserId: string;
  teams: TeamForFilter[];
  cards: Card[];
  sprints: Pick<Sprint, 'id' | 'teamId'>[];
  roadmaps: Pick<Roadmap, 'id' | 'teamId'>[];
  senderTeamId: string | null | undefined;
}): boolean {
  const { event: e, selectedTeamId, currentUserId, teams, cards, sprints, roadmaps, senderTeamId } = input;
  if (selectedTeamId == null) return true;

  const selectedTeam = teams.find((t) => t.id === selectedTeamId);
  if (!selectedTeam || selectedTeam.name === 'Company') return true;

  if (e.streamType === 'team_stream' && e.recipientStreamId === selectedTeamId) {
    return true;
  }

  if (e.cardId) {
    const c = cards.find((x) => x.id === e.cardId);
    if (c && c.teamId === selectedTeamId) return true;
  }
  if (e.sprintId) {
    const s = sprints.find((x) => x.id === e.sprintId);
    if (s && s.teamId === selectedTeamId) return true;
  }
  if (e.roadmapId) {
    const r = roadmaps.find((x) => x.id === e.roadmapId);
    if (r && r.teamId === selectedTeamId) return true;
  }

  if (e.cardId) {
    const card = cards.find((x) => x.id === e.cardId);
    if (!card || card.teamId == null || card.teamId === '') return true;
    return card.teamId === selectedTeamId;
  }

  if (e.streamType === 'team_stream' && e.recipientStreamId !== selectedTeamId) {
    return false;
  }

  if (e.userId === currentUserId) return true;
  if (senderTeamId === selectedTeamId) return true;

  return false;
}
